module.exports = "/_next/static/images/ea1628cdbbd5660a4e26c673f7a096cf-nucommunity-md@3x.jpg.webp";